import { getIsRasHH, getParamCookie, itemIsExpired, queryParam } from '../../Utils';
import Profiles from './Profiler/Profiles';
import { getProfileByPriority } from './Profiler/ProfileEngine';
import isEmpty from 'lodash.isempty';

export const profile = (state) => {
    const {
        engagementStatus,
        reenroll,
        isPrimary,
        archivedGroupSummary,
        pastEngagements,
        educationContinue,
        planningGroup,
    } = state;
    const { status } = engagementStatus;
    const clientHasActiveConsent = planningGroup?.clients?.some((client) => client.clientType === 'PRIMARY') &&
        !!planningGroup.clients.filter((client) => client.clientType === 'PRIMARY')[0]
            .activeConsent;
    const coClientHasActiveConsent =
        planningGroup?.clients?.some((client) => client.clientType !== 'PRIMARY') &&
        !!planningGroup.clients.filter((client) => client.clientType !== 'PRIMARY')[0]
            .activeConsent;
    const clientExpired = !clientHasActiveConsent;
    const coClientExpired = !coClientHasActiveConsent;
    const hasDocuments =
        state?.planningGroup?.latestReleasedFinancialPlan ||
        state?.planningGroup?.latestReleasedStrategyComparison ||
        state?.planningGroup?.latestReleasedSelectedStrategy;
    const checkEmailInv =
        !isPrimary && JSON.parse(sessionStorage.getItem('emailInv'))
            ? JSON.parse(sessionStorage.getItem('emailInv')).encodedUrlText
            : null;
    const getQueryParam = queryParam === 'ras-review' || queryParam === 'add-account';
    const limbo = archivedGroupSummary && archivedGroupSummary.archivedGroupsCount > 0;
    const isProspClient = state?.planningGroup?.activeEngagement?.engagementStatuses?.some(
        (x) => x.status === 'NEWP'
    );
    const isExpressEng = state?.planningGroup?.activeEngagement?.engagementStatuses?.some(
        (x) => x.status === 'NEWE'
    );
    const isLimbo = limbo && state?.planningGroup === null;
    const wasLimbo = limbo && state?.planningGroup !== null;
    const hasActiveEngagement = state?.planningGroup?.activeEngagement !== null;
    const hasExpiredPrcnEngagement = status === 'PRCN' && itemIsExpired(state?.planningGroup?.activeEngagement?.expirationDate);
    const hasPrcnNeedsConsent =
        hasActiveEngagement &&
        state?.planningGroup?.activeEngagement?.engagementStatuses?.some(
            (x) => x.status === 'PRCN'
        ) &&
        state?.currentClientData?.activeConsent === null;

    const hasEnteredPin =
        (!isPrimary && checkEmailInv && sessionStorage.getItem('invitePinNumber')) ||
        state.hasEnteredPin;
    const isRasHH = getIsRasHH(state?.planningGroup, engagementStatus);
    const isProspCompleted =
        state?.planningGroup?.activeEngagement?.engagementStatuses?.some(
            (x) => x.status === 'FPAC'
        ) &&
        state?.planningGroup?.activeEngagement?.engagementStatuses?.some(
            (x) => x.status === 'APND'
        );

    const conditions = {
        isNEWE: status === 'NEWE',
        isPRCN: status === 'PRCN',
        isCNGN: status === 'CNGN',
        isAPND: status === 'APND',
        isAPSC: status === 'APSC',
        isPLDL: status === 'PLDL',
        isNEWP: status === 'NEWP',
        isKYCC: status === 'KYCC',
        isGLSC: status === 'GLSC',
        isRTQC: status === 'RTQC',
        isINTC: status === 'INTC',
        isEXTC: status === 'EXTC',
        isMANC: status === 'MANC',
        isFPAC: status === 'FPAC',
        nullGroup: state?.planningGroup === null,
        notRasOnboarding: state.engagementType !== 'RAS-Onboarding' || localStorage.getItem('joiningRasHH'),
        clientExpired,
        pastEngagements: pastEngagements || wasLimbo,
        coClientExpired,
        isPrimary,
        isRasHH,
        multipleClients: state?.numberOfClients > 1,
        educationContinue,
        isReenroll: reenroll,
        hasEnteredPin,
        hasValidConsent: !isEmpty(state.currentClientData?.activeConsent),
        isRasActive: state?.rasActiveClient,
        hasDocuments,
        queryParam: getQueryParam || getParamCookie,
        isLimbo,
        limbo,
        isProspClient,
        isExpressEng,
        wasLimbo,
        isProspCompleted,
        hasActiveEngagement,
        hasExpiredPrcnEngagement,
        hasPrcnNeedsConsent,
    };

    const getProfile = getProfileByPriority(conditions, Profiles);

    if (queryParam === 'ras-review' || queryParam === 'add-account') {
        document.cookie = `from=${queryParam}; max-age=15`;
    }

    if (getProfile) {
        return getProfile;
    }

    return null;
};
